module.exports = __webpack_public_path__ + "static/media/academy-js.fe1fec3a.svg";